import { navigate } from 'gatsby-link';

const navigateTo = (url, newTab) => {
        
    // This is a hack to make it load the page correctly when navigating to a fragment url like /#signup
    // navigateTo is needed to navigate to other routed pages
    // but, it doesn't work properly with fragment urls within the page we are already on

    let pathWithoutFragmentTag = url.split('#')[0];
    if (newTab)
    {
        window.open(url, "_blank")
    }
    else if (pathWithoutFragmentTag === "/" &&
        window.location.pathname === "/")
    {
        window.location.href = url;
    }
    else if (url.startsWith("http"))
    {
        window.location.href = url;
    }
    else if (url.startsWith("mailto"))
    {
        window.location.href = url;
    }
    else
    {
        navigate(url)
    }
};


export default navigateTo;